var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "signup-form__container" }, [
    _vm.formState == "sending"
      ? _c("div", [
          _c("div", { staticClass: "overlay" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-sending" }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "signup-form" }, [
      _vm.formState == "sent"
        ? _c("div", { staticClass: "row" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm.formVisible
        ? _c(
            "form",
            {
              staticClass: "default",
              attrs: { method: "post", name: "send-quote" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.sendSignup.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "row justify-content-center" }, [
                _c("div", { staticClass: "col-md-8 text-center" }, [
                  _c("p", [
                    _vm._v(
                      "\n                        Rekisteröityminen on tarkoitettu esiintyjille,\n                        jotka haluavat lisätä oman bändinsä, kuoronsa, dj-palvelunsa, duonsa, jne.\n                        buukkaa-bandi.fi -palveluun. Rekisteröityminen ei ole tarpeen,\n                        mikäli haluat buukata bändin tai pyytää tarjousta esiitymisestä tilaisuudessasi\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "signup-form__basic-info" },
                    [
                      _vm.showInvitation
                        ? _c("invitation-notification", {
                            attrs: {
                              "invitation-id": _vm.invitationId,
                              "invitation-checksum": _vm.invitationChecksum,
                            },
                            on: {
                              "set-email": _vm.emailFromInvitation,
                              "set-invitation": _vm.setInvitation,
                              "error-occured": _vm.invitationError,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error": _vm.$v.firstname.$error,
                          },
                        },
                        [
                          _c("label", [_vm._v("Etunimesi")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.$v.firstname.$model,
                                expression: "$v.firstname.$model",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { type: "text", placeholder: "Etunimesi" },
                            domProps: { value: _vm.$v.firstname.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.firstname,
                                  "$model",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: {
                            "form-group--error": _vm.$v.lastname.$error,
                          },
                        },
                        [
                          _c("label", [_vm._v("Sukunimesi")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.$v.lastname.$model,
                                expression: "$v.lastname.$model",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { type: "text", placeholder: "Sukunimesi" },
                            domProps: { value: _vm.$v.lastname.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.lastname,
                                  "$model",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { "form-group--error": _vm.$v.phone.$error },
                        },
                        [
                          _c("label", [_vm._v("Puhelinnumerosi")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.phone.$model,
                                expression: "$v.phone.$model",
                              },
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "Puhelinnumerosi",
                            },
                            domProps: { value: _vm.$v.phone.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.phone,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { "form-group--error": _vm.$v.email.$error },
                        },
                        [
                          _c("label", [_vm._v("Sähköpostiosoitteesi")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.lazy",
                                value: _vm.$v.email.$model,
                                expression: "$v.email.$model",
                                modifiers: { lazy: true },
                              },
                            ],
                            attrs: {
                              disabled: _vm.emailEditDisabled() == true,
                              type: "text",
                              placeholder: "Sähköpostiosoitteesi",
                            },
                            domProps: { value: _vm.$v.email.$model },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.$v.email,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12 align-items-center text-center" },
                  [
                    _c("signup-tos", {
                      model: {
                        value: _vm.tosAccepted,
                        callback: function ($$v) {
                          _vm.tosAccepted = $$v
                        },
                        expression: "tosAccepted",
                      },
                    }),
                    _vm._v(" "),
                    !_vm.formDisabled
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--call-to-action",
                            attrs: { type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n                        Rekisteröidy\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [
      _c("p", [
        _vm._v(
          "Olemme lähettäneet ohjeet rekisteröitymisen vahvistamisesta sähköpostiisi."
        ),
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "/fi/login" } }, [
        _vm._v("Siirry kirjautumiseen"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }